import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  let tableClass = '.js-adv-banners-list';

  if($(tableClass).length) {
    // таблица
    let advBannersTable = $(tableClass).DataTable({
      'language': (BX.message('LANGUAGE_ID') === 'en' ? {
        emptyTable: 'Missing data in the table',
        info: '_START_ - _END_ from _TOTAL_',
        infoEmpty: '0 from 0',
        infoFiltered: '(Filtered records of _MAX_)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Elements per page _MENU_ ',
        loadingRecords: 'Loading...',
        processing: 'Loading...',
        search: 'Search:',
        zeroRecords: 'Not found',
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous'
        },
        aria: {
          sortAscending: ': activate the column to sort column ascending',
          sortDescending: ': activate the column to sort column descending',
          paginate: {
            first: 'First',
            last: 'Last',
            next: 'Next',
            previous: 'Previous'
          }
        }
      } : {
        emptyTable: 'Данные отсутствуют',
        info: '_START_ - _END_ из _TOTAL_',
        infoEmpty: '0 из 0',
        infoFiltered: '(Отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Выводить по _MENU_ ',
        loadingRecords: 'Загрузка...',
        processing: 'Загрузка...',
        search: 'Поиск: ',
        zeroRecords: 'Ничего не найдено',
        paginate: {
          first: 'Первый',
          last: 'Последний',
          next: 'Следующий',
          previous: 'Предыдущий'
        },
        aria: {
          sortAscending: ': активировать для сортировки столбца по возрастанию',
          sortDescending: ': активировать для сортировки столбца по убыванию',
          paginate: {
            first: 'Первый',
            last: 'Последний',
            next: 'Следующий',
            previous: 'Предыдущий'
          }
        }
      }),
      'columns': [
        {name: 'name', data: 'name', searchable: true, orderable: true, width: '20%'},
        {name: 'image', data: 'image', searchable: false, orderable: false, width: '10%'},
        {name: 'active', data: 'active', searchable: false, orderable: true, width: '5%'},
        {name: 'sort', data: 'sort', searchable: false, orderable: true, width: '5%'},
        {name: 'change_date', data: 'change_date', searchable: false, orderable: true},
        {name: 'changed', data: 'changed', searchable: false, orderable: true},
        {name: 'actions', data: 'actions', searchable: false, orderable: false, width: '130px'}
      ],
      'order': [[0, 'asc']],
      'lengthMenu': [
        [10, 20, 50, 100, 1000],
        [10, 20, 50, 100, (BX.message('LANGUAGE_ID') === 'en' ? 'All' : 'Все')]
      ],
      'processing': true,
      'serverSide': true,
      'stateSave': true,
      'stateDuration': -1,
      'ajax': {
        'url': '/local/ajax/office/AdvBanners/list/?lang='+(BX.message('LANGUAGE_ID') === 'en' ? 'en' : 'ru'),
        'type': 'POST'
      },
    });

    // удаление элемента
    $(tableClass).on('click', '.js-remove', function (event) {
      event.preventDefault();

      let apply = confirm(BX.message('LANGUAGE_ID') === 'en' ? 'Are you sure?' : 'Удаление элемента. Вы уверены?');
      if (apply) {
        let url = $(this).attr('href');
        if (url !== null && url !== '') {
          $.ajax({
            method: 'GET',
            url: url,
            dataType: 'json'
          }).done(function (data) {
            if (data.result) {
              advBannersTable.ajax.reload();
            } else {
              alert(BX.message('LANGUAGE_ID') === 'en' ? 'Error!' : 'Ошибка!')
            }
          }).fail(function () {
            alert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
          });
        }
      }
    });

    // фильтрация
    $(document).on('change', 'select.js-list-filter', function(){
      let v = $(this).val();
      let name = $(this).attr('name');

      if(v !== undefined && v !== null && v != '' && name !== undefined && name !== null){
        BX.setCookie(name, v, {path: '/'});
      }else{
        BX.setCookie(name, 1, {path: '/', expires: -1});
      }

      advBannersTable.ajax.reload();
    });
  }
});
